import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next'; // Importamos el hook
import './TestimonialsSection.css';
import tripadvisorLogo from '../../../assets/tripadvisor-logo.png';

interface Testimonial {
  id: number;
  quote: string;
  author: string;
}

const TestimonialsSection: React.FC = () => {
  // 1. Hook vacío
  const { t } = useTranslation();

  // 2. Obtenemos la lista con 'testimonials:list'
  const testimonialsJson = t('testimonials:list', { returnObjects: true }) as Testimonial[] | undefined;

  // 3. Fallback o asignación
  const testimonialsData: Testimonial[] = Array.isArray(testimonialsJson) ? testimonialsJson : [];

  const [currentIndex, setCurrentIndex] = useState(0);
  const [animate, setAnimate] = useState(false);
  const contentRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setAnimate(true);
          }
        });
      },
      {
        threshold: 0.5,
      }
    );

    if (contentRef.current) observer.observe(contentRef.current);

    return () => {
      if (contentRef.current) observer.unobserve(contentRef.current);
    };
  }, []);

  const handleNavClick = (index: number) => {
    setAnimate(false);
    setCurrentIndex(index);
    setTimeout(() => setAnimate(true), 50);
  };

  // Validación de seguridad por si el JSON tarda en cargar un milisegundo
  const currentTestimonial = testimonialsData[currentIndex];

  if (!currentTestimonial) return null; // O un loading spinner si prefieres

  return (
    <section className="testimonials-section">
      <div className="linea-global linea-separator-bottom"></div>
      <div
        ref={contentRef}
        className={`testimonial-content ${animate ? 'animate-in' : ''}`}
      >
        <img src={tripadvisorLogo} alt="TripAdvisor Logo" className="tripadvisor-logo" />
        
        {/* Mostramos datos dinámicos */}
        <p className="testimonial-quote">"{currentTestimonial.quote}"</p>
        <p className="testimonial-author">{currentTestimonial.author}</p>
      </div>

      <div className="testimonial-navigation">
        {testimonialsData.map((_, index) => (
          <span
            key={index}
            className={`nav-dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => handleNavClick(index)}
          ></span>
        ))}
      </div>
    </section>
  );
};

export default TestimonialsSection;